﻿const menu = document.querySelector(".main-menu");
menu.addEventListener("click", () => menu.classList.toggle("open"))
